import { IFramework } from '@truckdown/framework';
import { ActivityManager } from './ActivityManager';
import { CaptchaService } from './CaptchaService';
import { IActivityManager } from './IActivityManager';
import { ICaptchaService } from './ICaptchaService';
import { IIPCountryRangeManager } from './IIPCountryRangeManager';
import { IPCountryRangeManager } from './IPCountryRangeManager';
import { IRestrictionManager } from './IRestrictionManager';
import { IThrottleManager } from './IThrottleManager';
import { IThrottler } from './IThrottler';
import { RestrictionManager } from './RestrictionManager';
import { ThrottleManager } from './ThrottleManager';
import { Throttler } from './Throttler';

export default (framework: IFramework) => {
    framework.registerTransient<IActivityManager>('IActivityManager', (frm) => {
        return new ActivityManager(frm);
    });
    framework.registerTransient<ICaptchaService>('ICaptchaService', (frm) => {
        return new CaptchaService(frm);
    });
    framework.registerTransient<IIPCountryRangeManager>('IIPCountryRangeManager', (frm) => {
        return new IPCountryRangeManager(frm);
    });
    framework.registerTransient<IRestrictionManager>('IRestrictionManager', (frm) => {
        return new RestrictionManager(frm);
    });
    framework.registerTransient<IThrottleManager>('IThrottleManager', (frm) => {
        return new ThrottleManager(frm);
    });
    framework.registerTransient<IThrottler>('IThrottler', (frm) => {
        return new Throttler(frm);
    });
}